(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["biket-bike-compare"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BiketBikeCompare) return;

    const STORAGE_KEY = 'biket-bike-compare-v1';
    const MAX_BIKES = 3;
    const state = { bikes: [], copy: null, tray: null, modal: null };
    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const shorten = (value, length = 260) => value && value.length > length ? `${value.slice(0, length - 1).trim()}…` : value;
    const normalise = (value = '') => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const readState = () => {
      try { state.bikes = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]').slice(0, MAX_BIKES); }
      catch (error) { state.bikes = []; }
    };

    const saveState = () => {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state.bikes)); }
      catch (error) { /* Comparison still works for the current page. */ }
    };

    const getCopy = (button) => {
      if (state.copy) return state.copy;
      const data = button.dataset;
      state.copy = {
        add: data.copyAdd, remove: data.copyRemove, heading: data.copyHeading, hint: data.copyHint,
        oneSelected: data.copyOneSelected, manySelected: data.copyManySelected, open: data.copyOpen,
        clear: data.copyClear, close: data.copyClose, removeBike: data.copyRemoveBike,
        viewBike: data.copyViewBike, loading: data.copyLoading, max: data.copyMax,
        notListed: data.copyNotListed, price: data.copyPrice, bikeType: data.copyBikeType,
        sizes: data.copySizes, frame: data.copyFrame, fork: data.copyFork, shock: data.copyShock,
        drivetrain: data.copyDrivetrain, brakes: data.copyBrakes, wheels: data.copyWheels,
        tyres: data.copyTyres, weight: data.copyWeight
      };
      return state.copy;
    };

    const bikeFromButton = (button) => ({
      handle: button.dataset.productHandle,
      url: button.dataset.productUrl,
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      type: button.dataset.productType,
      finance: button.dataset.productFinance || ''
    });

    const syncButtons = () => {
      document.querySelectorAll('[data-biket-compare]').forEach((button) => {
        const selected = state.bikes.some((bike) => bike.handle === button.dataset.productHandle);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        const icon = button.querySelector('.biket-compare-toggle__icon');
        const label = button.querySelector('[data-biket-compare-label]');
        if (icon) icon.textContent = selected ? '✓' : '+';
        if (label && state.copy) label.textContent = selected ? state.copy.remove : state.copy.add;
      });
    };

    const ensureTray = () => {
      if (state.tray || !state.copy) return;
      const tray = document.createElement('aside');
      tray.className = 'biket-compare-tray';
      tray.hidden = true;
      tray.setAttribute('aria-label', state.copy.heading);
      tray.innerHTML = '<div class="biket-compare-tray__inner"><div class="biket-compare-tray__intro"><strong data-compare-count></strong><span></span></div><div class="biket-compare-tray__products" data-compare-products></div><div class="biket-compare-tray__actions"><button class="biket-compare-tray__clear" type="button" data-compare-clear></button><button class="biket-compare-tray__open" type="button" data-compare-open></button></div></div>';
      document.body.appendChild(tray);
      state.tray = tray;
      tray.querySelector('[data-compare-clear]').textContent = state.copy.clear;
      tray.querySelector('[data-compare-open]').textContent = state.copy.open;
      tray.querySelector('.biket-compare-tray__intro span').textContent = state.copy.hint;
    };

    const renderTray = () => {
      ensureTray();
      if (!state.tray) return;
      state.tray.hidden = state.bikes.length === 0;
      const count = state.tray.querySelector('[data-compare-count]');
      count.textContent = state.bikes.length === 1 ? state.copy.oneSelected : `${state.bikes.length} ${state.copy.manySelected}`;
      state.tray.querySelector('[data-compare-products]').innerHTML = state.bikes.map((bike) => `
        <div class="biket-compare-tray__product">
          ${bike.image ? `<img src="${escapeHtml(bike.image)}" alt="">` : '<span></span>'}
          <strong>${escapeHtml(bike.title)}</strong>
          <button class="biket-compare-tray__remove" type="button" data-compare-remove="${escapeHtml(bike.handle)}" aria-label="${escapeHtml(state.copy.removeBike)}">×</button>
        </div>`).join('');
      state.tray.querySelector('[data-compare-open]').disabled = state.bikes.length < 2;
    };

    const showAlert = (message) => {
      document.querySelector('.biket-compare-alert')?.remove();
      const alert = document.createElement('div');
      alert.className = 'biket-compare-alert';
      alert.setAttribute('role', 'status');
      alert.textContent = message;
      document.body.appendChild(alert);
      window.setTimeout(() => alert.remove(), 2800);
    };

    const removeBike = (handle) => {
      state.bikes = state.bikes.filter((bike) => bike.handle !== handle);
      saveState();
      syncButtons();
      renderTray();
      if (state.modal && !state.modal.hidden) {
        if (state.bikes.length < 2) closeModal();
        else renderComparison();
      }
    };

    const toggleBike = (button) => {
      getCopy(button);
      const bike = bikeFromButton(button);
      const existing = state.bikes.some((item) => item.handle === bike.handle);
      if (existing) removeBike(bike.handle);
      else {
        if (state.bikes.length >= MAX_BIKES) { showAlert(state.copy.max); return; }
        state.bikes.push(bike);
        saveState();
        syncButtons();
        renderTray();
      }
    };

    const ensureModal = () => {
      if (state.modal) return;
      const modal = document.createElement('section');
      modal.className = 'biket-compare-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'BiketCompareHeading');
      modal.innerHTML = `<header class="biket-compare-modal__header"><h2 id="BiketCompareHeading">${escapeHtml(state.copy.heading)}</h2><button class="biket-compare-modal__close" type="button" data-compare-close>${escapeHtml(state.copy.close)} <span aria-hidden="true">×</span></button></header><div class="biket-compare-modal__body" data-compare-body></div>`;
      document.body.appendChild(modal);
      state.modal = modal;
    };

    const closeModal = () => {
      if (!state.modal) return;
      state.modal.hidden = true;
      document.body.classList.remove('biket-compare-body-locked');
    };

    const extractProduct = async (bike) => {
      const response = await fetch(`/products/${encodeURIComponent(bike.handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product details unavailable');
      const product = await response.json();
      const documentFragment = new DOMParser().parseFromString(product.description || '', 'text/html');
      const specs = new Map();
      documentFragment.querySelectorAll('tr').forEach((row) => {
        const heading = row.querySelector('th');
        const value = row.querySelector('td');
        if (!heading || !value) return;
        const key = normalise(heading.textContent);
        const text = value.textContent.replace(/\s+/g, ' ').trim();
        if (key && text && !specs.has(key)) specs.set(key, shorten(text));
      });

      const exact = (labels) => {
        for (const label of labels) if (specs.has(label)) return specs.get(label);
        return '';
      };
      const combine = (labels) => [...new Set(labels.map((label) => exact([label])).filter(Boolean))].join(' · ');
      const sizeOption = (product.options || []).find((option) => normalise(option.name) === 'size');
      const sizes = sizeOption && Array.isArray(sizeOption.values) ? sizeOption.values.join(', ') : '';

      return {
        ...bike,
        type: product.type || bike.type,
        sizes,
        frame: exact(['frame']),
        fork: exact(['fork']),
        shock: exact(['shock']),
        drivetrain: combine(['rear derailleur', 'shifter', 'cassette', 'crank']),
        brakes: combine(['brake', 'brakes', 'brake set', 'brake lever']),
        wheels: combine(['wheel front', 'front wheel', 'wheel rear', 'rear wheel', 'wheelset', 'rim']),
        tyres: combine(['tyre', 'tire', 'tyre front', 'front tyre', 'tyre rear', 'rear tyre']),
        weight: exact(['weight'])
      };
    };

    const renderComparison = async () => {
      ensureModal();
      const body = state.modal.querySelector('[data-compare-body]');
      body.innerHTML = `<div class="biket-compare-modal__loading">${escapeHtml(state.copy.loading)}</div>`;
      const products = await Promise.all(state.bikes.map(async (bike) => {
        try { return await extractProduct(bike); }
        catch (error) { return bike; }
      }));
      const rows = [
        { key: 'price', label: state.copy.price }, { key: 'type', label: state.copy.bikeType },
        { key: 'sizes', label: state.copy.sizes }, { key: 'frame', label: state.copy.frame },
        { key: 'fork', label: state.copy.fork }, { key: 'shock', label: state.copy.shock },
        { key: 'drivetrain', label: state.copy.drivetrain }, { key: 'brakes', label: state.copy.brakes },
        { key: 'wheels', label: state.copy.wheels }, { key: 'tyres', label: state.copy.tyres },
        { key: 'weight', label: state.copy.weight }
      ].filter((row) => ['price', 'type', 'sizes'].includes(row.key) || products.some((product) => product[row.key]));

      const top = `<div class="biket-compare-grid__corner"></div>${products.map((product) => `
        <article class="biket-compare-grid__product">
          <button class="biket-compare-grid__remove" type="button" data-compare-remove="${escapeHtml(product.handle)}" aria-label="${escapeHtml(state.copy.removeBike)}">×</button>
          ${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : ''}
          <h3>${escapeHtml(product.title)}</h3>
          <div class="biket-compare-grid__price">${escapeHtml(product.price)}</div>
          <div class="biket-compare-grid__finance">${escapeHtml(product.finance || '')}</div>
          <a class="biket-compare-modal__view" href="${escapeHtml(product.url)}">${escapeHtml(state.copy.viewBike)}</a>
        </article>`).join('')}`;
      const tableRows = rows.map((row) => {
        const values = products.map((product) => product[row.key] || state.copy.notListed);
        const different = new Set(values).size > 1;
        return `<div class="biket-compare-grid__label">${escapeHtml(row.label)}</div>${values.map((value) => `<div class="biket-compare-grid__value${different ? ' biket-compare-grid__value--different' : ''}">${escapeHtml(value)}</div>`).join('')}`;
      }).join('');
      body.innerHTML = `<div class="biket-compare-grid" style="--compare-count:${products.length}">${top}${tableRows}</div>`;
    };

    const openModal = async () => {
      if (state.bikes.length < 2) return;
      ensureModal();
      state.modal.hidden = false;
      document.body.classList.add('biket-compare-body-locked');
      state.modal.querySelector('[data-compare-close]').focus();
      await renderComparison();
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-biket-compare]');
      if (toggle) { event.preventDefault(); toggleBike(toggle); return; }
      const remove = event.target.closest('[data-compare-remove]');
      if (remove) { removeBike(remove.dataset.compareRemove); return; }
      if (event.target.closest('[data-compare-clear]')) { state.bikes = []; saveState(); syncButtons(); renderTray(); return; }
      if (event.target.closest('[data-compare-open]')) { openModal(); return; }
      if (event.target.closest('[data-compare-close]')) closeModal();
    });

    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && state.modal && !state.modal.hidden) closeModal(); });

    const initialise = () => {
      const firstButton = document.querySelector('[data-biket-compare]');
      if (!firstButton) return;
      getCopy(firstButton);
      readState();
      syncButtons();
      renderTray();
    };

    window.BiketBikeCompare = { initialise, open: openModal, close: closeModal };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["biket-editorial-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseMenuAim = (root = document) => {
      root.querySelectorAll('.site-header .site-header__nav-standalone .site-nav').forEach((nav) => {
        if (nav.dataset.biketMenuAim === 'true') return;

        const items = [...nav.children].filter((item) =>
          item.querySelector(':scope > .site-nav__dropdown.standard-dropdown')
        );

        if (!items.length) return;

        nav.dataset.biketMenuAim = 'true';
        nav.classList.add('biket-menu-aim');

        let activeItem = null;
        let switchTimer = null;
        let closeTimer = null;

        const clearTimers = () => {
          window.clearTimeout(switchTimer);
          window.clearTimeout(closeTimer);
        };

        const closeMenu = () => {
          clearTimers();
          items.forEach((item) => {
            item.classList.remove('is-biket-menu-open');
            item.querySelector(':scope > .site-nav__link')?.setAttribute('aria-expanded', 'false');
          });
          activeItem = null;
        };

        const openMenu = (item) => {
          clearTimers();
          items.forEach((menuItem) => {
            const isActive = menuItem === item;
            menuItem.classList.toggle('is-biket-menu-open', isActive);
            menuItem
              .querySelector(':scope > .site-nav__link')
              ?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          });
          activeItem = item;
        };

        items.forEach((item) => {
          const trigger = item.querySelector(':scope > .site-nav__link');
          trigger?.setAttribute('aria-expanded', 'false');

          item.addEventListener('pointerenter', () => {
            window.clearTimeout(closeTimer);
            window.clearTimeout(switchTimer);

            if (!activeItem || activeItem === item) {
              openMenu(item);
              return;
            }

            switchTimer = window.setTimeout(() => openMenu(item), 260);
          });

          item.addEventListener('pointerleave', () => {
            window.clearTimeout(switchTimer);
          });

          item.addEventListener('focusin', () => openMenu(item));

          trigger?.addEventListener('click', (event) => {
            if (trigger.getAttribute('href') !== '#') return;
            event.preventDefault();
            if (activeItem === item) closeMenu();
            else openMenu(item);
          });
        });

        nav.addEventListener('pointerleave', () => {
          closeTimer = window.setTimeout(closeMenu, 220);
        });

        nav.addEventListener('pointerenter', () => {
          window.clearTimeout(closeTimer);
        });

        nav.addEventListener('focusout', (event) => {
          if (!nav.contains(event.relatedTarget)) closeMenu();
        });

        nav.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const trigger = activeItem?.querySelector(':scope > .site-nav__link');
          closeMenu();
          trigger?.focus();
        });
      });
    };

    initialiseMenuAim();
    document.addEventListener('shopify:section:load', (event) => initialiseMenuAim(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
